import { render, staticRenderFns } from "./prescription-details.vue?vue&type=template&id=362b0d22&"
import script from "./prescription-details.vue?vue&type=script&lang=js&"
export * from "./prescription-details.vue?vue&type=script&lang=js&"
import style0 from "./prescription-details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QIcon,QSkeleton,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QIcon,QSkeleton,QImg})
